require('./mortgageRequestEstates.scss');

const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const { isEqual, isEmpty, range, each } = require('lodash');

// @ helpers
const { addOrdinal, stringToBoolean } = require('utilities/stringHelper');
const { getLanguage } = require('core/i18n').i18n;

// @ components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AdditionalEstateInfo } = require('./components/aditionalEstateInfo');
const ModalDelete = require('./modalDelete');
const { text } = require('components/mortgageRequest/mortgageRequestEstates/initialValues');
const AnotherEstatesInputMinusPlus = require('./anotherEstatesInputMinusPlus');

// @ actions
const { deleteEstate, showModal, resetDeleteEstate, updateEstate } = require('actions/mortgageRequest/mortgageRequestEstates');

// @ constants
const { VIVIENDA } = require('constants/mortgageRequestEstates').ESTATES_TYPE_ABBREVIATION;

class AnotherEstates extends React.Component {
    constructor(props) {
        super(props);
        this.deletingEstate = false;
        this.showModal = false;
        this.canEdit = true;
        this.answer = true;
        this.idxSelected = 0;
        this.nameSelected = '';
        this.estateSelected = {};
        this.ammounts = {
            storageRoom: 0,
            garage: 0
        };
        this.childs = {
            storageRoom: [],
            garage: []
        };

        this.estatesPartLivingPlace = {
            storageRoom: 0,
            garage: 0
        };

        this.configAddtionalEstate = {
            garage: {
                label: 'GARAGE',
                type: 'G'
            },
            storageRoom: {
                label: 'STORAGE_ROOM',
                type: 'T'
            }
        };

        this.handleBtnClick = this.handleBtnClick.bind(this);
        this.handleChangeAnswer = this.handleChangeAnswer.bind(this);
        this.handleChild = this.handleChild.bind(this);
        this.buildData = this.buildData.bind(this);
        this.handleDeleteEstate = this.handleDeleteEstate.bind(this);
        this.handleConfirmDeleteEstate = this.handleConfirmDeleteEstate.bind(this);
    }

    componentWillMount() {
        this.props.onBuildData(this.buildData);
        isEmpty(this.props.anotherEstatesData) || this.setData();
    }

    componentWillReceiveProps(nextProps) {
        if (
            !isEqual(this.props.anotherEstatesData, nextProps.anotherEstatesData)
            ||
            !isEqual(this.props.livingPlaceAddressData, nextProps.livingPlaceAddressData)
        ) {
            this.setData(nextProps);
        }
    }

    componentWillUnmount() {
        this.props.onBuildData(() => {});
    }

    setData(nextProps = null) {
        const props = nextProps || this.props;
        this.canEdit = false;
        this.estatesPartLivingPlace = {
            storageRoom: parseInt(props.livingPlaceAddressData.storageRooms, 10) || 0,
            garage: parseInt(props.livingPlaceAddressData.garages, 10) || 0
        };

        const { garages, storageRooms } = props.anotherEstatesData;

        this.answer = isEmpty(garages) && isEmpty(storageRooms);

        this.ammounts.garage = garages.length + this.estatesPartLivingPlace.garage;
        this.ammounts.storageRoom = storageRooms.length + this.estatesPartLivingPlace.storageRoom;

    }

    buildAdditionalEstateComponent(name) {

        if (this.ammounts[name] > 0) {

            return range(1, 1 + this.ammounts[name]).map(idx => {

                let isPartLivingPlace = false;
                let estateData = {};

                const normalIdx = idx - 1;

                if (this.estatesPartLivingPlace[name] > 0) {

                    if (this.estatesPartLivingPlace[name] > normalIdx) {
                        isPartLivingPlace = true;

                    } else {

                        if (this.props.anotherEstatesData[`${name}s`] && this.props.anotherEstatesData[`${name}s`][normalIdx - this.estatesPartLivingPlace[name]]) {
                            estateData = this.props.anotherEstatesData[`${name}s`][normalIdx - this.estatesPartLivingPlace[name]];
                        }
                    }

                } else {

                    if (this.props.anotherEstatesData[`${name}s`] && this.props.anotherEstatesData[`${name}s`][normalIdx]) {
                        estateData = this.props.anotherEstatesData[`${name}s`][normalIdx];
                    }
                }

                const showLink = !this.canEdit &&
                    (
                        estateData.id ||
                        idx <= parseInt(this.props.livingPlaceAddressData[`${name}s`], 10)
                    );

                const link = showLink && <a href="#" onClick={evt => this.handleDeleteEstate(evt, idx, name, true, estateData)} className="mortgage-request-estates__delete-link">{text().ANOTHER_ESTATES.DELETE}</a>;

                return (
                    <div className="col-xs-12" key={idx}>
                        <Accordion id={`${name}EstateAccordion`} onClick={() => { }} isExpanded>
                            <AccordionHeader name="AccordionHeader" isRightArrowPosition>
                                <h3>
                                    {addOrdinal(getLanguage(), idx)} {text().LABEL[this.configAddtionalEstate[name].label]}
                                    {link}
                                </h3>
                            </AccordionHeader>
                            <AccordionBody name="AccordionBody">
                                <AdditionalEstateInfo
                                    idx={idx}
                                    type={this.configAddtionalEstate[name].type}
                                    onBuildData={buildData => this.handleChild(name, buildData)}
                                    estateData={estateData}
                                    livingPlaceAddressData={this.props.livingPlaceAddressData}
                                    isPartLivingPlace={isPartLivingPlace}
                                />
                            </AccordionBody>
                        </Accordion>
                    </div>
                )
            });
        }
    }

    buildAnotherEstates() {

        if (!this.answer) {

            return (
                <div className="row">
                    <div className="col-xs-12">
                        <h2>{text().ANOTHER_ESTATES.DETAIL_INFO}</h2>
                        <div className="row">
                            {this.buildAdditionalEstateComponent('garage')}
                            {this.buildAdditionalEstateComponent('storageRoom')}
                        </div>
                    </div>
                </div>
            );
        }
    }

    buildAnotherEstatesQuestion() {
        if (this.ammounts.garage > 0 || this.ammounts.storageRoom > 0) {
            const textValue = text();
            return (
                <div className="row">
                    <div className="col-xs-12">
                        <h3>{textValue.ANOTHER_ESTATES.QUESTITON}</h3>
                    </div>

                    <div className="col-xs-12">
                        <RadioButtonGroup
                            name="motive"
                            idPrefix="radioButtonAnotherEstates"
                            selectedValue={this.answer}
                            onChange={this.handleChangeAnswer}
                            className="account-cancel-chequebook-step__radio-group"
                        >
                            <RadioButton label={textValue.ANOTHER_ESTATES.ANSWER.POSITIVE} value className="block-step__radio" />
                            <RadioButton label={textValue.ANOTHER_ESTATES.ANSWER.NEGATIVE} value={false} className="block-step__radio" />
                        </RadioButtonGroup>
                    </div>

                    <div className="col-xs-12">
                        {this.buildAnotherEstates()}
                    </div>
                </div>
            )
        }
    }

    buildData() {
        const anotherEstatesData = {
            storageRoomData: [],
            garageData: [],
            ammounts: {
                garage: 0,
                storageRoom: 0
            }
        };

        let ok = true;

        each(this.childs.storageRoom, buildData => {
            const data = buildData();

            if (!data) {
                ok = false;

                return false;
            } else {

                anotherEstatesData.storageRoomData.push(data);
                (isEmpty(data) || data.delete) && anotherEstatesData.ammounts.storageRoom++;
            }
        });

        each(this.childs.garage, buildData => {
            const data = buildData();

            if (!data) {
                ok = false;

                return false;
            } else {

                anotherEstatesData.garageData.push(data);
                (isEmpty(data) || data.delete) && anotherEstatesData.ammounts.garage++;
            }
        });

        if (isEmpty(this.childs.storageRoom) && isEmpty(this.childs.garage)) {
            anotherEstatesData.ammounts.garage = this.ammounts.garage;
            anotherEstatesData.ammounts.storageRoom = this.ammounts.storageRoom;
        }

        return ok ? anotherEstatesData : false;
    }

    deleteEstateFromLivingPlace(name) {

        const livingPlaceEstate = this.props.inmueblesState
            .get('list')
            .find(estate => estate.get('type') === VIVIENDA || estate.get('propertyType') === VIVIENDA);

        const newAmount = (parseInt(livingPlaceEstate.get(`${name}s`), 10) - 1).toString();

        this.props.updateEstateAction(livingPlaceEstate.set(`${name}s`, newAmount));
    }

    handleBtnClick(type, operator) {

        const lastValue = this.ammounts[type];
        const result = operator === '+' ? lastValue + 1 : lastValue - 1;

        if (result < 0) {
            return false;
        }

        if (!this.canEdit) {

            if (
                !this.answer &&
                operator === '-' &&
                result < this.props.anotherEstatesData[`${type}s`].length + parseInt(this.props.livingPlaceAddressData[`${type}s`], 10)
            ) {

                return false;
            }
        }

        this.ammounts[type] = result;

        this.forceUpdate();
    }

    handleChangeAnswer(answer) {
        if (answer === 'true') {
            const { storageRooms, garages } = this.props.anotherEstatesData;

            if (!isEmpty(storageRooms) || !isEmpty(garages)) {
                return false;
            }
        }

        this.answer = stringToBoolean(answer);
        this.forceUpdate();
    }

    handleChild(type, buildDataChild) {

        if (buildDataChild) {
            this.childs[type].push(buildDataChild);
        } else {
            this.childs[type].pop();
        }
    }

    handleConfirmDeleteEstate(evt, idx, name) {
        if (this.estateSelected.id) {
            this.props.deleteEstateAction(this.estateSelected.id);
        } else {
            this.deleteEstateFromLivingPlace(name);
        }
    }

    handleDeleteEstate(evt, idx, name, showModal, estateSelected = {}) {
        evt && evt.preventDefault();
        if (!this.deletingEstate) {
            this.idxSelected = idx;
            this.nameSelected = name;
            this.estateSelected = estateSelected;
            this.props.showModalAction(showModal);
        }

    }

    render() {
        const textValue = text();
        const config = {
            storageRoom: {
                label: textValue.ANOTHER_ESTATES.BTN.ADD_STORAGE_ROOM,
                value: this.ammounts.storageRoom,
                type: 'storageRoom',
                showBtns: true,
                disableInput: false
            },
            garage: {
                label: textValue.ANOTHER_ESTATES.BTN.ADD_GARAGE,
                value: this.ammounts.garage,
                type: 'garage',
                showBtns: true,
                disableInput: false
            }
        };

        const modal = this.props.inmueblesState.get('showModal') ? ModalDelete(
            this.idxSelected,
            this.nameSelected,
            this.handleDeleteEstate,
            this.handleConfirmDeleteEstate,
            this.props.inmueblesState.get('isFetching')
        ) : '';

        return (
            <div className="row">
                <div className="col-xs-12">
                    <label className="ok-input__label mortgage-request-estates-view__label" >{textValue.ANOTHER_ESTATES.SUBTITLE}</label>
                    <br />
                </div>
                <AnotherEstatesInputMinusPlus
                    config={config.garage}
                    onHandleBtnClick={this.handleBtnClick}
                />
                <AnotherEstatesInputMinusPlus
                    config={config.storageRoom}
                    onHandleBtnClick={this.handleBtnClick}
                />

                <br />
                <div className="col-xs-12">
                    {this.buildAnotherEstatesQuestion()}
                </div>
                {modal}
            </div>
        );
    }
}

AnotherEstates.propTypes = {
    onBuildData: PropTypes.func,
    anotherEstatesData: PropTypes.object,
    livingPlaceAddressData: PropTypes.object,
    inmueblesState: PropTypes.object,
    estatesState: PropTypes.object,
    deleteEstateAction: PropTypes.func,
    showModalAction: PropTypes.func,
    resetDeleteEstateAction: PropTypes.func,
    updateEstateAction: PropTypes.func
};

module.exports.constructor = AnotherEstates;

module.exports.AnotherEstates = connect(state => ({
    inmueblesState: state.mortgageRequestInmuebles,
    estatesState: state.mortgageRequestEstates,
}), {
        deleteEstateAction: deleteEstate,
        showModalAction: showModal,
        resetDeleteEstateAction: resetDeleteEstate,
        updateEstateAction: updateEstate
    })(AnotherEstates);
